export class CalculationRequest {
  uuid: string;
  sessionId: string;
  mandantId: string;
  tariffOptionConfigurations;
  prices;
}
